import PasswordProtect from './PasswordProtect'

export default PasswordProtect
